import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const PCM = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };

    const sections = [
        { title: 'Adventurers', href: 'Adventurers' },
        { title: 'Pathfinders', href: 'Pathfinders' },
        { title: 'Ambassadors', href: 'Ambassadors' },
        { title: 'Young Adults', href: 'YoungAdults' }
    ];

    return (
        <>
            <div className="min-h-screen bg-gradient-to-b from-indigo-50 to-purple-50">
                <Header />
                
                <main className="pt-24">
                    <div className="max-w-7xl mx-auto px-4">
                        {/* Navigation */}
                        <nav className="mb-12">
                            <div className="flex flex-wrap gap-2 justify-center">
                                {sections.map((section, idx) => (
                                    <a
                                        key={idx}
                                        href={section.href}
                                        className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-6 py-3 rounded-full font-semibold hover:from-indigo-700 hover:to-purple-700 transform hover:scale-105 transition-all duration-300 shadow-lg"
                                    >
                                        {section.title}
                                    </a>
                                ))}
                            </div>
                        </nav>

                        {/* Vision & Objectives */}
                        <div className="grid md:grid-cols-2 gap-8 mb-20">
                            <div className="bg-gradient-to-br from-white to-indigo-50 rounded-3xl shadow-2xl p-8 transform hover:-translate-y-1 transition-all duration-300">
                                <div className="flex items-center mb-6">
                                    <div className="bg-gradient-to-r from-indigo-500 to-purple-500 p-3 rounded-xl mr-4">
                                        <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                        </svg>
                                    </div>
                                    <h2 className="text-3xl font-bold text-gray-800">Vision</h2>
                                </div>
                                <div className="space-y-4 text-gray-600 leading-relaxed">
                                    <p>The goal of the General Conference Public Campus Ministry is to see young people grounded in the mission of Jesus Christ and the Seventh-day Adventist Church, and able to reach and engage their fellow campus students in life-long relationships with Jesus.</p>
                                    <p>Public Campus Ministry not only concerns itself with nurturing students but also supporting Adventist professors and others who work at public campuses.</p>
                                    <p className="mt-6">
                                        <a 
                                            href="https://www.gcyouthministries.org/resources/public-campus-ministries/amicus/"
                                            className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-semibold transition-colors duration-300"
                                        >
                                            AMiCUS – (Adventist Ministry to College and University Students)
                                            <svg className="w-4 h-4 ml-2" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>
                                            </svg>
                                        </a>
                                    </p>
                                </div>
                            </div>

                            <div className="bg-gradient-to-br from-white to-purple-50 rounded-3xl shadow-2xl p-8 transform hover:-translate-y-1 transition-all duration-300">
                                <div className="flex items-center mb-6">
                                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-3 rounded-xl mr-4">
                                        <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>
                                        </svg>
                                    </div>
                                    <h2 className="text-3xl font-bold text-gray-800">Objectives</h2>
                                </div>
                                <div className="space-y-4">
                                    {[
                                        'To promote a vibrant Public Campus Ministry',
                                        'To prepare students to deal with intellectual challenges that arise in a secular environment',
                                        'To equip Chapter/Association/Fellowship Leaders',
                                        'To provide for the needs of Students on Public Campuses',
                                        'To equip students with the necessary skills and competencies to navigate Campus life',
                                        'To encourage students to "GO" by training them for outreach and witnessing on and off campus',
                                        'To inspire Adventist students to increase their commitment to Christ',
                                        'To motivate Adventist students to achieve excellence in all spheres'
                                    ].map((item, idx) => (
                                        <div key={idx} className="flex items-start">
                                            <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-1 rounded-full mr-3 mt-1">
                                                <FontAwesomeIcon icon={faCheck} className="text-white text-xs" />
                                            </div>
                                            <span className="text-gray-600">{item}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Features */}
                        <div className="bg-gradient-to-br from-white to-indigo-50 rounded-3xl shadow-2xl p-8 mb-20">
                            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">PCM Features & Programs</h2>
                            
                            <div className="grid md:grid-cols-3 gap-6">
                                {[
                                    {
                                        title: 'Campus Ministry',
                                        description: 'Engaging students through Bible studies, prayer groups, and spiritual mentoring on public campuses.',
                                        color: 'from-blue-500 to-cyan-500'
                                    },
                                    {
                                        title: 'Leadership Development',
                                        description: 'Training student leaders to organize and lead campus ministries effectively.',
                                        color: 'from-purple-500 to-pink-500'
                                    },
                                    {
                                        title: 'Outreach Programs',
                                        description: 'Organizing evangelistic events, community service, and mission projects.',
                                        color: 'from-emerald-500 to-green-500'
                                    },
                                    {
                                        title: 'Academic Support',
                                        description: 'Providing tutoring, study groups, and academic counseling for students.',
                                        color: 'from-amber-500 to-orange-500'
                                    },
                                    {
                                        title: 'Social Activities',
                                        description: 'Creating Christian fellowship opportunities through social events and activities.',
                                        color: 'from-red-500 to-pink-500'
                                    },
                                    {
                                        title: 'Career Guidance',
                                        description: 'Offering career counseling and professional development workshops.',
                                        color: 'from-indigo-500 to-purple-500'
                                    }
                                ].map((feature, idx) => (
                                    <div key={idx} className="bg-white rounded-2xl p-6 shadow-lg transform hover:-translate-y-2 transition-all duration-300">
                                        <div className={`h-2 bg-gradient-to-r ${feature.color} rounded-full mb-4`}></div>
                                        <h3 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h3>
                                        <p className="text-gray-600">{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Call to Action */}
                        <div className="relative rounded-3xl overflow-hidden mb-20">
                            <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-600"></div>
                            <div className="relative z-10 p-12 text-center">
                                <h2 className="text-4xl font-bold text-white mb-6">Join Our Campus Ministry</h2>
                                <p className="text-indigo-100 text-lg mb-8 max-w-2xl mx-auto">
                                    Connect with fellow Adventist students on your campus. Grow spiritually, build friendships, and make a difference in your academic community.
                                </p>
                                <div className="flex flex-wrap gap-4 justify-center">
                                    <a 
                                        href="#"
                                        className="bg-white text-indigo-600 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 shadow-lg"
                                    >
                                        Find Your Campus Group
                                    </a>
                                    <a 
                                        href="#"
                                        className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-full font-bold hover:bg-white/10 transform hover:scale-105 transition-all duration-300"
                                    >
                                        Become a Leader
                                    </a>
                                </div>
                            </div>
                            
                            {/* Decorative elements */}
                            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mt-16 -mr-16"></div>
                            <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -mb-12 -ml-12"></div>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
}

export default PCM;